import { render, staticRenderFns } from "./TelegramMessageForm.vue?vue&type=template&id=1189567c&scoped=true&"
import script from "./TelegramMessageForm.vue?vue&type=script&lang=js&"
export * from "./TelegramMessageForm.vue?vue&type=script&lang=js&"
import style0 from "./TelegramMessageForm.vue?vue&type=style&index=0&id=1189567c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1189567c",
  null
  
)

export default component.exports